module.exports = __webpack_public_path__ + "img/pointspay.12e9be2f.svg";